import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

//material ui components:
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

//actions:
import { modifyFieldOtrosDatos } from '../../../actions/cierre_diario_actions';
import {  setSaveState } from '../../../actions';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';
import FloatPercentFormatInput from '../../../components/float_percent_input_formatter';


//styles:
const styles = theme => ({
    container: {
        width: '48%',
        height: 165,
    },
    paperTitle: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        margin: 0,
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#e6e6e6',
        padding: '4px 2px 4px 12px',
        marginBottom: 5,
        borderBottom: '3px solid #b8b8b8',
    },
    headerRowItem: {
        fontSize: 13,
        fontWeight: '700',
        margin: 0,
        width: '50%',
        padding: '0 10px',
    },
    gridRow: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 11,
        padding: '2px 10px',
        borderBottom: '1px solid #8bc34a',
        "&:last-child": {
            borderBottom: 'none',
            paddingBottom: 3,
            fontWeight: '700',
        },
    },
    rowItem: {
        width: '50%',
        padding: '0 10px',
        fontWeight: '500',
    },
    rtl: {
        textAlign: 'right',
    },
    leftSide: {
        paddingLeft: 10,
    },
    inputsSide: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '60%'
    },
    input: {
        width: 30,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    inputImporte: {
        textAlign: 'right',
        margin: '4px 5px 4px 2px',
        padding: 0,
        fontSize: 12,
        height: 14,
    },
    lastInput: {
        height: 25,
        fontWeight: '700',
        [`& fieldset`]: {
            borderColor: 'transparent !important',
        },
    },
});

class SatisfaccionTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            //encuesta, satisfaccion:
            //op. local
            ilusionaOp1M: !this.props.otrosDatosCierreDiario.ilusionaOp1M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1M,
            ilusionaOp1R: !this.props.otrosDatosCierreDiario.ilusionaOp1R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1R,
            ilusionaOp1B: !this.props.otrosDatosCierreDiario.ilusionaOp1B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1B,
            ilusionaOp1E: !this.props.otrosDatosCierreDiario.ilusionaOp1E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1E,
            //op. personal
            ilusionaOp2M: !this.props.otrosDatosCierreDiario.ilusionaOp2M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2M,
            ilusionaOp2R: !this.props.otrosDatosCierreDiario.ilusionaOp2R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2R,
            ilusionaOp2B: !this.props.otrosDatosCierreDiario.ilusionaOp2B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2B,
            ilusionaOp2E: !this.props.otrosDatosCierreDiario.ilusionaOp2E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2E,
            // op. maquinas
            ilusionaOp3M: !this.props.otrosDatosCierreDiario.ilusionaOp3M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3M,
            ilusionaOp3R: !this.props.otrosDatosCierreDiario.ilusionaOp3R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3R,
            ilusionaOp3B: !this.props.otrosDatosCierreDiario.ilusionaOp3B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3B,
            ilusionaOp3E: !this.props.otrosDatosCierreDiario.ilusionaOp3E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3E,
            // op. precio
            ilusionaOp4M: !this.props.otrosDatosCierreDiario.ilusionaOp4M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4M,
            ilusionaOp4R: !this.props.otrosDatosCierreDiario.ilusionaOp4R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4R,
            ilusionaOp4B: !this.props.otrosDatosCierreDiario.ilusionaOp4B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4B,
            ilusionaOp4E: !this.props.otrosDatosCierreDiario.ilusionaOp4E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4E,
            // resultado:
            resultadoIlusionaPor100: !this.props.otrosDatosCierreDiario.resultadoIlusionaPor100 ? 0 : this.props.otrosDatosCierreDiario.resultadoIlusionaPor100,

            editing: false
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreDiario !== this.props.otrosDatosCierreDiario) {
            this.setState({
                //encuesta, satisfaccion:
                //op. local
                ilusionaOp1M: !this.props.otrosDatosCierreDiario.ilusionaOp1M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1M,
                ilusionaOp1R: !this.props.otrosDatosCierreDiario.ilusionaOp1R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1R,
                ilusionaOp1B: !this.props.otrosDatosCierreDiario.ilusionaOp1B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1B,
                ilusionaOp1E: !this.props.otrosDatosCierreDiario.ilusionaOp1E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp1E,
                //op. personal
                ilusionaOp2M: !this.props.otrosDatosCierreDiario.ilusionaOp2M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2M,
                ilusionaOp2R: !this.props.otrosDatosCierreDiario.ilusionaOp2R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2R,
                ilusionaOp2B: !this.props.otrosDatosCierreDiario.ilusionaOp2B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2B,
                ilusionaOp2E: !this.props.otrosDatosCierreDiario.ilusionaOp2E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp2E,
                // op. maquinas
                ilusionaOp3M: !this.props.otrosDatosCierreDiario.ilusionaOp3M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3M,
                ilusionaOp3R: !this.props.otrosDatosCierreDiario.ilusionaOp3R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3R,
                ilusionaOp3B: !this.props.otrosDatosCierreDiario.ilusionaOp3B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3B,
                ilusionaOp3E: !this.props.otrosDatosCierreDiario.ilusionaOp3E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp3E,
                // op. precio
                ilusionaOp4M: !this.props.otrosDatosCierreDiario.ilusionaOp4M ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4M,
                ilusionaOp4R: !this.props.otrosDatosCierreDiario.ilusionaOp4R ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4R,
                ilusionaOp4B: !this.props.otrosDatosCierreDiario.ilusionaOp4B ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4B,
                ilusionaOp4E: !this.props.otrosDatosCierreDiario.ilusionaOp4E ? 0 : this.props.otrosDatosCierreDiario.ilusionaOp4E,
                // resultado:
                resultadoIlusionaPor100: !this.props.otrosDatosCierreDiario.resultadoIlusionaPor100 ? 0 : this.props.otrosDatosCierreDiario.resultadoIlusionaPor100,

                editing: false
            });
        };
    };


    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value, editing: true });
    };


    onBlur = (event, field) => {
        const value = parseInt(this.state[field])

        this.setState({ ...this.state, [field]: value, editing: false });
        this.props.setSaveState(true);
        this.props.modifyFieldOtrosDatos(field, value);
    };

    resultadoEncuesta = () => {

        if (this.state.editing) return;

        let resultDB = 0,
            numberOfAnswers = 0;

        const obj = this.state;

        for (const key in obj)
            if (obj[key] !== 0)
                numberOfAnswers += obj[key];

        if (numberOfAnswers)
            resultDB = ((
                ((parseInt(this.state.ilusionaOp1M) + parseInt(this.state.ilusionaOp2M) + parseInt(this.state.ilusionaOp3M) + parseInt(this.state.ilusionaOp4M)) * 25) +
                ((parseInt(this.state.ilusionaOp1R) + parseInt(this.state.ilusionaOp2R) + parseInt(this.state.ilusionaOp3R) + parseInt(this.state.ilusionaOp4R)) * 50) +
                ((parseInt(this.state.ilusionaOp1B) + parseInt(this.state.ilusionaOp2B) + parseInt(this.state.ilusionaOp3B) + parseInt(this.state.ilusionaOp4B)) * 75) +
                ((parseInt(this.state.ilusionaOp1E) + parseInt(this.state.ilusionaOp2E) + parseInt(this.state.ilusionaOp3E) + parseInt(this.state.ilusionaOp4E)) * 100)

            ) / numberOfAnswers);

        return resultDB;
    };


    render() {

        const { classes } = this.props;

        return (
            <div className={classes.container}>
                {/* header row */}
                <div className={classes.headerRow}>
                    <h5 className={classes.headerRowItem}>Satisfacción</h5>
                    <h5 className={classes.headerRowItem}>M</h5>
                    <h5 className={classes.headerRowItem}>R</h5>
                    <h5 className={classes.headerRowItem}>B</h5>
                    <h5 className={classes.headerRowItem}>MB</h5>
                </div>

                {/* second row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Local</div>
                    <div className={classes.inputsSide}>
                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp1M'}
                            value={this.state.ilusionaOp1M}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp1M')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp1M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp1M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp1R'}
                            value={this.state.ilusionaOp1R}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp1R')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp1R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp1R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp1B'}
                            value={this.state.ilusionaOp1B}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp1B')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp1B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp1B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp1E'}
                            value={this.state.ilusionaOp1E}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp1E')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp1E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp1E') };
                            }}
                        />
                    </div>


                </div>

                {/* third row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Personal</div>
                    <div className={classes.inputsSide}>
                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp2M'}
                            value={this.state.ilusionaOp2M}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp2M')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp2M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp2M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp2R'}
                            value={this.state.ilusionaOp2R}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp2R')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp2R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp2R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp2B'}
                            value={this.state.ilusionaOp2B}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp2B')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp2B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp2B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp2E'}
                            value={this.state.ilusionaOp2E}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp2E')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp2E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp2E') };
                            }}
                        />
                    </div>

                </div>

                {/* fourth row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Comida</div>
                    <div className={classes.inputsSide}>
                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp3M'}
                            value={this.state.ilusionaOp3M}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp3M')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp3M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp3M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp3R'}
                            value={this.state.ilusionaOp3R}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp3R')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp3R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp3R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp3B'}
                            value={this.state.ilusionaOp3B}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp3B')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp3B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp3B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp3E'}
                            value={this.state.ilusionaOp3E}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp3E')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp3E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp3E') };
                            }}
                        />
                    </div>

                </div>


                {/* fifth row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Precio</div>
                    <div className={classes.inputsSide}>
                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp4M'}
                            value={this.state.ilusionaOp4M}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp4M')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp4M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp4M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp4R'}
                            value={this.state.ilusionaOp4R}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp4R')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp4R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp4R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp4B'}
                            value={this.state.ilusionaOp4B}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp4B')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp4B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp4B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'ilusionaOp4E'}
                            value={this.state.ilusionaOp4E}
                            onChange={(event) => this.handleValueChange(event, 'ilusionaOp4E')}
                            onBlur={(event) => this.onBlur(event, 'ilusionaOp4E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'ilusionaOp4E') };
                            }}
                        />
                    </div>

                </div>


                {/* sixth row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Resultado</div>
                    <TextField
                        id={'ilusionaOp4E'}
                        disabled
                        fullWidth
                        variant='outlined'
                        className={classes.lastInput}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatPercentFormatInput }}
                        value={this.resultadoEncuesta()}

                    />
                </div>
            </div>
        );
    };
};


SatisfaccionTable.propTypes = {
    otrosDatosCierreDiario: PropTypes.object.isRequired,
    modifyFieldOtrosDatos: PropTypes.func.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreDiario: state.otrosDatosCierreDiario.datos,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyFieldOtrosDatos,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(SatisfaccionTable));